import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { colors, fonts } from '../../theme/tokens';

/**
 * Wave 6 — minimal offline / reconnect UX over persistent Firestore cache.
 */
export default function ReconnectBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' ? !navigator.onLine : false
  );

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    window.addEventListener('fightdecks:offline', goOffline);
    window.addEventListener('fightdecks:online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
      window.removeEventListener('fightdecks:offline', goOffline);
      window.removeEventListener('fightdecks:online', goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <Box
      role="status"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: 2,
        py: 1,
        minHeight: 48,
        bgcolor: colors.panelRaised || '#1a1d24',
        borderBottom: `1px solid ${colors.brassDark || '#8a7340'}`,
        color: colors.brass || '#c4a35a',
      }}
    >
      <Typography
        sx={{
          fontFamily: fonts.numeric || fonts.body,
          fontSize: '0.75rem',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
        }}
      >
        Offline — showing cached data. Reconnect to sync.
      </Typography>
      <Button
        size="small"
        onClick={() => window.location.reload()}
        sx={{
          color: colors.brass,
          borderColor: colors.brass,
          minHeight: 36,
          textTransform: 'uppercase',
          fontFamily: fonts.numeric || fonts.body,
          fontSize: '0.7rem',
        }}
        variant="outlined"
      >
        Reload
      </Button>
    </Box>
  );
}
